<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.orderSubNo" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secah.tel" placeholder="请输入联系人电话" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="value" type="datetimerange" :picker-options="pickerOptions" value-format='yyyy-MM-dd HH:mm:ss' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="secah.orderType" placeholder="请选择订单类型" clearable>

            <el-option label="商城订单" :value="1">
            </el-option>
            <el-option label="拼团订单" :value="2">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item>
          <el-select v-model="secah.orderSubStatus" placeholder="请选择订单状态" clearable>

            <!-- <el-option label="待支付" :value="1">
						</el-option> -->
            <el-option label="待发货" :value="2">
            </el-option>
            <el-option label="已发货" :value="3">
            </el-option>
            <el-option label="已完成" :value="4">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="daochu.supplierName" placeholder="请输入供应商名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="daochu.startTime" value-format="yyyy-MM-dd" type="date" placeholder="开始时间">
          </el-date-picker>

        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="daochu.endTime" value-format="yyyy-MM-dd" type="date" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click='daochuClick'>导出</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="orderSubNo" label="订单号" align="center">
        </el-table-column>
        <el-table-column prop="orderType" label="订单类型" align="center">
          <template slot-scope="scope">
            {{scope.row.totalSubPromotionCoupons > 0 ? '推广订单' : scope.row.orderType==2?'拼团订单':"商城订单"}}
          </template>
        </el-table-column>
        <el-table-column prop="orderSubStatus" label="订单转态" align="center">
          <template slot-scope="scope">
            {{scope.row.orderSubStatus==1?'待支付':scope.row.orderSubStatus==2?"待发货":scope.row.orderSubStatus==3?"已发货":"已完成"}}
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="供货商" align="center">
        </el-table-column>
        <el-table-column prop="totalOrderSubAmount" label="商品价格" align="center">
        </el-table-column>
        <el-table-column prop="freight" label="订单运费" align="center">
        </el-table-column>
        <el-table-column label="订单总价" align="center">
          <template slot-scope="scope">
            {{(scope.row.totalOrderSubAmount*100+scope.row.freight*100)/100}}
          </template>
        </el-table-column>
        <el-table-column label="订单积分" align="center">
          <template slot-scope="scope">
            {{scope.row.bpsType==1?0:scope.row.totalSubIntegral}}
          </template>
        </el-table-column>
        <el-table-column prop="totalSubJkcMoney" label="JCK券" align="center">
        </el-table-column>
        <el-table-column label="奖励积分" align="center">
          <template slot-scope="scope">
            {{scope.row.bpsType==1?0:scope.row.totalSubPromotionCoupons}}
          </template>
        </el-table-column>

        <el-table-column prop="receiveName" label="联系人" align="center">
        </el-table-column>
        <el-table-column prop="receiveTel" label="联系人电话" align="center">
        </el-table-column>
        <el-table-column prop="address" label="收货人地址" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.orderSubStatus==2" @click="deliver(scope.row)">发货</el-button>
            <el-button size="mini" type="primary" @click="detailsClick(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="订单信息" :visible.sync="dialogVisible" :modal-append-to-body='false' width="60%">
      <div>
        <el-descriptions title="">
          <el-descriptions-item label="订单号">{{details.orderSubNo}}</el-descriptions-item>
          <el-descriptions-item label="订单转态">
            {{details.orderSubStatus==1?'待支付':details.orderSubStatus==2?"待发货":details.orderSubStatus==3?"已发货":"已完成"}}
          </el-descriptions-item>
          <el-descriptions-item label="订单价格">{{details.totalOrderSubAmount}}</el-descriptions-item>

          <el-descriptions-item label="运费">{{details.freight}}</el-descriptions-item>
          <el-descriptions-item label="供货商名称">{{details.supplierName}}</el-descriptions-item>
          <el-descriptions-item label="快递公司">{{details.expressCompany}}</el-descriptions-item>
          <el-descriptions-item label="快递单号">{{details.expressNo}}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{details.address}}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{details.receiveName}}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{details.receiveTel}}</el-descriptions-item>
          <el-descriptions-item label="发货时间">{{details.consignmentTime}}</el-descriptions-item>
          <el-descriptions-item label="收货时间">{{details.receiveTime}}</el-descriptions-item>
          <el-descriptions-item label="订单时间">{{details.createTime}}</el-descriptions-item>
        </el-descriptions>
        <!-- <div class="el-descriptions-item__container"><span
						class="el-descriptions-item__label has-colon ">备注</span><span
						class="el-descriptions-item__content">备注备注备注备注备注备注备注
						备注备注备注备注备注备注备注
						备注备注备注备注备注备注备注
						备注备注备注备注备注备注备注</span></div> -->
        <el-table :data="details.orderDetailList" style="width: 100%;margin-top: 20px;" border>
          <el-table-column prop="goodsName" label="商品名称" align="center">
          </el-table-column>
          <el-table-column prop="attribute" label="商品属性" align="center">
            <template slot-scope="scope">
              <span>{{goodsSpecsStr(scope.row.goodsSpecs)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="goodsPrice" label="商品价格" align="center">
          </el-table-column>
          <el-table-column prop="goodsNum" label="购买数量" align="center">
          </el-table-column>
          <el-table-column prop="integral" label="积分" align="center">
          </el-table-column>
          <el-table-column prop="jkcMoney" label="JKC券" align="center">
          </el-table-column>

        </el-table>
      </div>

    </el-dialog>

    <el-dialog title="发货信息" :close-on-click-modal='false' :close-on-press-escape='false' :visible.sync="isDeliver" :modal-append-to-body='false' width="600px">
      <el-form :model="form">
        <el-form-item label="快递公司" label-width='100px'>
          <el-input v-model="form.expressCompany" placeholder="请输入快递公司" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="快递单号" label-width='100px'>
          <el-input v-model="form.expressNo" placeholder="请输入快递单号" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isDeliver = false">取 消</el-button>
        <el-button type="primary" @click="subDeliver()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import url from '@/common/serveice.js'
import store from '@/store'
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      value: '',
      tableData: [],
      total: 0,
      secah: {
        orderSubStatus: '',
        pageNum: 1,
        pageSize: 10,
        orderSubNo: '',
        tel: '',
        orderType: '',
      },
      dialogVisible: false,
      details: {},
      isDeliver: false,
      form: {
        expressCompany: '',
        expressNo: '',
        orderSubId: '',
      },
      daochu: {
        supplierName: '',
        startTime: '',
        endTime: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    //过滤属性
    goodsSpecsStr(goodsSpecs) {
      var str = ''
      var goodsSpecs = JSON.parse(goodsSpecs)
      for (var key in goodsSpecs) {
        str += key + '：' + goodsSpecs[key] + ' '
      }
      return str
    },
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    daochuClick() {
      // this.httpGet('/order/exportExcel', this.daochu).then((res) => {
      //   console.log(res.data.content)
      //   if (res.code == 200) {

      //   }
      // })
      // window.location.href = url.url + 'order/exportExcel?startTime=' + this.daochu.startTime + '&endTime=' + this.daochu.endTime + '&supplierName=' + this.daochu.supplierName
      var xhr = new XMLHttpRequest()
      var formData = new FormData()
			let _this = this
      xhr.open('get', url.url + 'order/exportExcel?startTime=' + this.daochu.startTime + '&endTime=' + this.daochu.endTime + '&supplierName=' + this.daochu.supplierName) // url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
      xhr.setRequestHeader('token', store.state.token)
      xhr.responseType = 'blob'
      xhr.onload = function (e) {
        if (this.status === 200) {
          var blob = this.response
          // xls文件名称
          var filename = `订单.xlsx`
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename)
          } else {
            var a = document.createElement('a')
            var url = _this.createObjectURL(blob)
            a.href = url
            a.download = filename
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send(formData)
    },
		createObjectURL (object) {
			return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object)
		},   //详情
    detailsClick(row) {
      this.httpPost(
        '/order/getSubOne?' + this.$qs.stringify({ orderSubId: row.orderSubId })
      ).then((res) => {
        console.log(res.data)
        if (res.code == 200) {
          this.details = res.data
          this.dialogVisible = true
        }
      })
    },
    //发货
    deliver(row) {
      this.form = {
        expressCompany: '',
        expressNo: '',
        orderSubId: '',
      }
      this.form.orderSubId = row.orderSubId
      this.isDeliver = true
    },
    //填写发货信息
    subDeliver() {
      if (this.form.expressCompany.length == 0) {
        this.$message('请输快递公司名称')
        return false
      }
      if (this.form.expressNo.length == 0) {
        this.$message('请输快递单号')
        return false
      }
      this.httpPost(
        '/order/deliverGoods?' + this.$qs.stringify(this.form)
      ).then((res) => {
        console.log(res.data)
        if (res.code == 200) {
          this.$message.success('发货成功')
          //this.$emit('closeMoule', true)
          this.isDeliver = false
          this.getList()
        }
      })
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    //获取列表信息
    getList() {
      console.log(this.value)
      if (this.value) {
        this.secah.startTime = this.value[0]
        this.secah.endTime = this.value[1]
      }
      this.httpPost('/order/orderSubByPage', this.secah, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
        console.log(res.data.content)
        if (res.code == 200) {
          this.tableData = res.data.content
          this.total = res.data.total
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
